

function initLoadMore(){

  const products_on_page = document.getElementById('product-grid');

  if (products_on_page) {
    let next_url = products_on_page.dataset.nextUrl;

    const load_more_btn = document.getElementsByClassName('load-more_btn')[0];
    const load_more_spinner = document.getElementsByClassName('load-more_spinner')[0];

    async function getNextPage() {
      try {
        let res = await fetch(next_url);
        return await res.text();
      } catch (error) {
        console.log(error);
      }
    }

    async function loadMoreProducts() {
      load_more_btn.style.display = 'none';
      load_more_spinner.style.display = 'block';
      let nextPage = await getNextPage();

      const parser = new DOMParser();
      const nextPageDoc = parser.parseFromString(nextPage, 'text/html');

      load_more_spinner.style.display = 'none';

      const productgrid = nextPageDoc.getElementById('product-grid');
      const new_products = productgrid.getElementsByClassName('grid__item');
      const new_url = productgrid.dataset.nextUrl;
      if (new_url) {
        load_more_btn.style.display = 'block';
      }
      next_url = new_url;
      for (let i = 0; i < new_products.length; i++) {
        let single_product = new_products[i].cloneNode(true);
        products_on_page.appendChild(single_product);
      }
    }

    // Add event listener for products (if button exists)
    if (load_more_btn) {
      load_more_btn.addEventListener('click', loadMoreProducts);
    }
  }

}

// Blog Articles Load More
const articles_on_page = document.getElementById('blog-article');

if (articles_on_page) {
 
  //Get the Next Page URL
  let next_url_blog = articles_on_page.dataset.nextUrl;

  const load_more_btn_blog = document.getElementsByClassName('load-more_btn-blog')[0];

  const load_more_spinner_blog = document.getElementsByClassName('load-more_spinner-blog')[0];

  async function getNextPageBlog() {
    try {
      let response = await fetch(next_url_blog); // Fetches the next page HTML
     

      return await response.text();   // Returns the HTML as text
    } catch (error) {
      console.log(error);
    }
  }

  async function loadMoreArticles() {
    load_more_btn_blog.style.display = 'none';
    load_more_spinner_blog.style.display = 'block';
    let nextPageBlog = await getNextPageBlog();
   
    /*Creates a DOMParser (tool to convert text into usable HTML)
      Converts the HTML text into a document we can search through
      Now nextPageBlogDoc is like a virtual copy of page 2 */

    const parserBlog = new DOMParser();
    const nextPageBlogDoc = parserBlog.parseFromString(nextPageBlog, 'text/html');

    
    load_more_spinner_blog.style.display = 'none';

    //Extract Articles from Next Page
    const bloggrid = nextPageBlogDoc.getElementById('blog-article');

    const new_blogs = bloggrid.getElementsByClassName('blog-articles__article');
    const new_url_blog = bloggrid.dataset.nextUrl;
  
    
    if (new_url_blog) {
     
      load_more_btn_blog.style.display = 'block';
      next_url_blog = new_url_blog;  // Update URL to page 3
    }
    
    //Add New Articles to Page
    for (let i = 0; i < new_blogs.length; i++) {
      let single_blog = new_blogs[i].cloneNode(true);// Copy the article
      articles_on_page.appendChild(single_blog);  // Add to current page
    } 
  }

  // Add event listener for blog articles (if button exists)
  if (load_more_btn_blog) {
    load_more_btn_blog.addEventListener('click', loadMoreArticles);
  }
}






document.addEventListener('DOMContentLoaded', initLoadMore);


